<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>ProManualx</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <i class="fa fa-home "></i>
                    <span>ProManualy </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<h2>Stuff</h2>
<div class="component-container heightcls">
    <div class="component-content heightcls">
        <div class="jumbotron" style="overflow-y:scroll; height: 100%; margin:0">
            <h1>ProManual Administration</h1>
            <p>Welcome to the ProManual Administration application!</p>
        </div>
    </div>
</div>
<h2>Stuff 2</h2>
<!--<login></login>-->